module.exports = __webpack_public_path__ + "static/media/ic_curtain_close.36b394c2.png";